import classNames from "classnames";

interface IconPlaceholderProps {
  title: string;
  size?: "large" | "medium" | "small";
  withBorder?: boolean;
}

function IconPlaceholder({
  title,
  size = "large",
  withBorder,
}: IconPlaceholderProps) {
  const initials = title?.slice(0, 1);

  if (size === "small") {
    return (
      <div
        className={classNames(
          "text-white text-sm font-bold flex items-center justify-center bg-[#292D33] h-[30px] w-[30px] min-h-[30px] min-w-[30px]  rounded-[50%]",
          withBorder ? "border border-gray-100" : ""
        )}
      >
        {initials}
      </div>
    );
  }

  if (size === "medium") {
    return (
      <div
        className={classNames(
          "text-white text-sm font-bold flex items-center justify-center bg-[#292D33] h-[29px] w-[29px] min-h-[29px] min-w-[29px]  rounded-[50%]",
          withBorder ? "border border-gray-100" : ""
        )}
      >
        {initials}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "text-white text-sm font-bold flex items-center justify-center bg-[#292D33] h-[32px] w-[32px] min-h-[32px] min-w-[32px] rounded-[50%]",
        withBorder ? "border border-gray-100" : ""
      )}
    >
      {initials}
    </div>
  );
}

export default IconPlaceholder;
